import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '@/components/PageTitle';
import { Spin, Divider, Card, Switch } from 'antd';
import { Form } from "@ant-design/compatible";
import ReactHtmlParser from 'react-html-parser';
import CommentsComponent from '@/components/CommentsComponent';
import { fetchFeedbackRequestDetail, updateFeedbackRequest } from '@/redux/actions/feedbackRequestActions';
import { processHTML } from '@/utils/helpers';
import { checkPermission } from '@/utils/permission';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/feedback-requests',
        breadcrumbName: 'Yêu cầu chỉnh sửa',
    },
    {
        path: '#',
        breadcrumbName: 'Chi tiết',
    },
]

class FeedbackRequestDetail extends Component {

    constructor() {
        super();
        this.state = {
            isLoading: false, // loading table
            isOpenForm: false,
            currentData: null,
            openView: false,
        }

        this.routeName = 'feedback_requests';
        this.allowCreate = checkPermission(this.routeName, 'create');
        this.allowUpdate = checkPermission(this.routeName, 'update');
        this.allowDelete = checkPermission(this.routeName, 'remove');
    }

    componentDidMount() {
        this.props.fetchFeedbackRequestDetail(this.props.match.params.id).then(() => {
            this.setState({ isLoading: false })
        })
    }

    reloadData() {
        this.props.fetchFeedbackRequestDetail(this.props.match.params.id).then(() => {
            this.setState({ isLoading: false, submitting: false })
        })
        this.props.form.resetFields();
    }

    render() {
        var { currentFeedbackRequest } = this.props;
        var { isLoading } = this.state;

        if (isLoading || !currentFeedbackRequest) {
            return (
                <div className="text-center" style={{ position: 'absolute', top: '50%', left: '50%' }}>
                    <Spin size="large" />
                </div>
            )
        }

        return (
            <div>
                <PageTitle routes={routes} title={currentFeedbackRequest?.title} />
                {
                    currentFeedbackRequest ? (
                        <Card
                            className='mt-2'
                            extra={<div className="text-right">
                                <Switch
                                    onChange={(checked) => this.props.updateFeedbackRequest(currentFeedbackRequest.id, { status: checked ? 1 : 0 })}
                                    defaultChecked={currentFeedbackRequest.status}
                                    checkedChildren="Đã hoàn thành"
                                    unCheckedChildren="Chưa hoàn thành"
                                    disabled={!this.allowUpdate}
                                />
                            </div>}
                        >
                            <h5 style={{ padding: '12px 15px' }}> {currentFeedbackRequest?.title}</h5>
                            <div className="view ql-editor training-img chingo-content-detail">
                                {ReactHtmlParser(processHTML(currentFeedbackRequest?.content))}
                            </div>
                            <Divider />
                            <CommentsComponent
                                reloadData={() => this.reloadData()}
                                commentsData={currentFeedbackRequest.comments}
                                type="feedback_requests"
                                parentId={currentFeedbackRequest?.id}
                            />
                        </Card>
                    ) : null
                }
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {
        currentFeedbackRequest: state.feedbackRequestReducer.currentFeedbackRequest,
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        fetchFeedbackRequestDetail: (id) => dispatch(fetchFeedbackRequestDetail(id)),
        updateFeedbackRequest: (id, data) => dispatch(updateFeedbackRequest(id, data)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: "FeedbackRequestDetail" })(FeedbackRequestDetail));